import { render } from "./SecurityProfileListPage.vue?vue&type=template&id=4527804a&scoped=true&ts=true"
import script from "./SecurityProfileListPage.vue?vue&type=script&lang=ts"
export * from "./SecurityProfileListPage.vue?vue&type=script&lang=ts"

import "./SecurityProfileListPage.vue?vue&type=style&index=0&id=4527804a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4527804a"]])

export default __exports__